// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "map" + "." + "0de0fced36d9a5d55b88" + ".min.css";
};